import { memo } from 'react'

import TeeterTotterPage, { TEST_ID } from './TeeterTotter'

const TeeterTotter = memo(TeeterTotterPage)

export { TEST_ID }

export default TeeterTotter
